import React from 'react';
import './CemeteryStatsGrid.css';

const STAT_FIELDS = [
  { key: 'plots', label: 'Plots' },
  { key: 'persons', label: 'Persons' },
  { key: 'interments', label: 'Interments' },
  { key: 'applications', label: 'Applications' },
  { key: 'stories', label: 'Stories' },
  { key: 'events', label: 'Events' },
  { key: 'notes', label: 'Notes' },
  { key: 'sections', label: 'Sections' },
  { key: 'lots', label: 'Lots' },
  { key: 'section_geofiles', label: 'Section GeoFiles' },
  { key: 'lot_geofiles', label: 'Lot GeoFiles' },
  { key: 'plot_geofiles', label: 'Plot GeoFiles' },
];

function CemeteryStatsGrid({ statistics, title, onRefresh, children }) {
  return (
    <div className="card">
      <h2>{title || 'Cemetery Data Overview'}</h2>
      <p className="text-muted">Current data in {statistics.cemetery_name}</p>
      <div className="stats-grid">
        {STAT_FIELDS.map(({ key, label }) => (
          <div className="stat-item" key={key}>
            <div className="stat-label">{label}</div>
            <div className="stat-value">{(statistics[key] || 0).toLocaleString()}</div>
          </div>
        ))}
        <div className="stat-item stat-total">
          <div className="stat-label">Total Records</div>
          <div className="stat-value">{(statistics.total_records || 0).toLocaleString()}</div>
        </div>
      </div>
      <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
        {onRefresh && (
          <button onClick={onRefresh} className="btn btn-secondary btn-sm">
            Refresh Statistics
          </button>
        )}
        {children}
      </div>
    </div>
  );
}

export default CemeteryStatsGrid;
